import { frontendNumber } from "utils/frontendNumber"

export const NeutralNumber = (number: number) => {
  return (
    <span className={`${number === 0 ? "tw-text-primary-50" : ""}`}>
      {frontendNumber(number)}
    </span>
  )
}
